export const DISCORD_OAUTH2_LINK =
  "https://discord.com/oauth2/authorize?client_id=1217762180301062206&response_type=code&redirect_uri=https%3A%2F%2Fpolygame.io%2Flogin&scope=identify+email";

export const DISCORD_PLATFORM = "website";
